<template>
    <b-card :id="id" :class="options.class">
        <div v-if="caption !== '' && (options.headerStyle === '1' || options.headerStyle === undefined)" slot="header">
            {{caption}}
            <div v-if="subCaption !== ''" class="small text-muted">{{subCaption}}</div>
            <b-link v-if="options.collapse" v-b-toggle="'collapseCard' + id" class="card-header-action btn-setting pull-right"><i class="fa fa-chevron-down"></i></b-link>
        </div>
        <div class="mb-4" v-if="caption !== '' && options.headerStyle === '2'">
            <h5 class="card-title mb-0">{{caption}}</h5>
            <div v-if="subCaption !== ''" class="small text-muted">{{subCaption}}</div>
            <b-link v-if="options.collapse" v-b-toggle="'collapseCard' + id" class="card-header-action btn-setting pull-right"><i class="fa fa-chevron-down"></i></b-link>
        </div>

        <b-collapse v-if="options.collapse === true" :id="'collapseCard' + id" class="mt-2"  :visible="dataVisible">
            <slot v-if="cardKey !== ''" :name="cardKey"></slot>
            <FormCardRows v-model="dataFieldRefs" :fieldRefs="fieldRefs" :form="form" v-if="rows !== undefined" :rows="rows"></FormCardRows>
            <FormFields  v-model="dataFieldRefs" :fieldRefs="fieldRefs" :form="form" v-if="fields !== undefined" :fields="fields"></FormFields>
            <FormTabs  v-model="dataFieldRefs" :fieldRefs="fieldRefs" :form="form" v-if="tabs !== undefined" :tabs="tabs"></FormTabs>
        </b-collapse>
        <div v-else>
            <slot v-if="cardKey !== ''" :name="cardKey"></slot>
            <FormCardRows  v-model="dataFieldRefs" :fieldRefs="fieldRefs" :form="form" v-if="rows !== undefined" :rows="rows"></FormCardRows>
            <FormFields  v-model="dataFieldRefs" :fieldRefs="fieldRefs" :form="form" v-if="fields !== undefined" :fields="fields"></FormFields>
            <FormTabs  v-model="dataFieldRefs" :fieldRefs="fieldRefs" :form="form" v-if="tabs !== undefined" :tabs="tabs"></FormTabs>
        </div>

    </b-card>
</template>
<script>
    import FormCardRows from './FormCardRows'
    import FormFields from './FormFields'
    import FormTabs from './FormTabs'
    export default {
        name: 'FormCard',
        components: {
            FormCardRows,
            FormFields,
            FormTabs
        },
        props: {
            id: {
                type: String,
                default: ''
            },
            options: {
                type: Object,
                default: function() {
                    return {
                        headerStyle: '1',
                        class: '',
                        collapse: false
                    }
                }
            },
            cardKey: {
                type: String,
                default: ''
            },
            caption: {
                type: String,
                default: ''
            },
            subCaption: {
                type: String,
                default: ''
            },
            tabs: {
                type: Array,
                default: function () {
                    return []
                }
            },
            rows: {
                type: Array,
                default: function () {
                    return []
                }
            },
            fields: {
                type: Array,
                default: function () {
                    return []
                }
            },
            form: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            fieldRefs: {
                type: Array,
                default: function() { return [] }
            },
            value: {
                type: Array | Object,
                default: function() { return [] }
            }
        },
        watch: {
            value(val) {
                this.dataFieldRefs = val
            },
            dataFieldRefs(val) {
                this.$emit('input', val)
            }
        },
        mounted() {
            this.dataFieldRefs = this.value
          if (this.options.collapse !== undefined) {
              if (this.options.collapse === true) {
                  this.dataVisible = false
              }
          }
        },
        data: function () {
            return {
                dataVisible: true,
                dataFieldRefs: [],
            }
        }
    }
</script>

